import { render, staticRenderFns } from "./SubproductTabComponent.vue?vue&type=template&id=c9fe742e&scoped=true&"
import script from "./SubproductTabComponent.vue?vue&type=script&lang=js&"
export * from "./SubproductTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubproductTabComponent.vue?vue&type=style&index=0&id=c9fe742e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fe742e",
  null
  
)

export default component.exports